import { canShareBookUploads } from '../bookSharing';
import React, { useEffect, useState } from 'react';
import { Modal, Text, TextInput, Button } from '@mantine/core';
import axios from '../axiosInstance';

export default function AudioShare({ book, language, myId, onClose }) {
  const en = language === 'en';
  const [query, setQuery] = useState(''), [users, setUsers] = useState([]), [state, setState] = useState(null);
  const [busy, setBusy] = useState(false), [searching, setSearching] = useState(false);
  useEffect(() => { setQuery(''); setUsers([]); setState(null); setBusy(false); }, [book?.id]);
  useEffect(() => {
    const q = query.trim();
    setUsers([]);
    if (!canShareBookUploads(myId) || !book || !q) { setSearching(false); return undefined; }
    let cancelled = false; setSearching(true);
    const timer = setTimeout(() => {
      axios.get(`/searchUsers?userName=${encodeURIComponent(q)}&limit=8&allUsers=true`)
        .then(r => { if (!cancelled) setUsers((r.data || []).filter(u => u.id !== myId)); })
        .catch(() => { if (!cancelled) setState({ error: true }); })
        .finally(() => { if (!cancelled) setSearching(false); });
    }, 250);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [query, book, myId]);
  const share = async user => {
    if (!canShareBookUploads(myId)) return;
    setBusy(true); setState(null);
    try { await axios.post(`/audio/${book.id}/share`, { userId: user.id }); setState({ name: user.userName }); setQuery(''); setUsers([]); }
    catch (_) { setState({ error: true }); } finally { setBusy(false); }
  };
  return <Modal opened={canShareBookUploads(myId) && !!book} onClose={onClose} title={en ? 'Share audiobook' : 'Поделиться аудиокнигой'} centered size="sm" zIndex={1300}>
    <Text size="sm" c="dimmed" mb="sm">{book?.label}</Text>
    <TextInput aria-label={en ? 'User name' : 'Имя пользователя'} placeholder={en ? 'User name' : 'Имя пользователя'} value={query} disabled={busy} onChange={e => { setQuery(e.currentTarget.value); setState(null); }} data-autofocus />
    {users.map(user => <Button key={user.id} fullWidth variant="subtle" mt="xs" disabled={busy} onClick={() => share(user)}>{user.userName}</Button>)}
    {searching && <Text size="xs" mt="xs">{en ? 'Searching…' : 'Поиск…'}</Text>}
    {!searching && query.trim() && !users.length && !state && <Text size="xs" c="dimmed" mt="xs">{en ? 'Nobody found' : 'Никого не нашлось'}</Text>}
    {state?.name && <Text role="status" c="teal" mt="sm">{en ? `${state.name} can now listen to this audiobook.` : `${state.name} теперь может слушать эту аудиокнигу.`}</Text>}
    {state?.error && <Text role="alert" c="red" mt="sm">{en ? 'Could not share. Please try again.' : 'Не удалось поделиться. Попробуйте ещё раз.'}</Text>}
  </Modal>;
}
